import i18n from './config';

const LOCALES = ['lv', 'en', 'ru'] as const;
const DEFAULT_LOCALE = 'lv';

export function stripLocalePrefix(path: string): string {
  const segments = path.split('/').filter(Boolean);
  if (segments.length > 0 && LOCALES.includes(segments[0] as (typeof LOCALES)[number])) {
    segments.shift();
  }

  return segments.length ? `/${segments.join('/')}` : '/';
}

export function localizedPathFor(path: string, locale: string): string {
  const base = stripLocalePrefix(path.startsWith('/') ? path : `/${path}`);

  if (locale === DEFAULT_LOCALE) {
    return base;
  }

  return base === '/' ? `/${locale}` : `/${locale}${base}`;
}

export function localizedPath(path: string): string {
  return localizedPathFor(path, i18n.locale || DEFAULT_LOCALE);
}

export function localeSwitchHref(targetLocale: string): string {
  const { pathname, search, hash } = window.location;
  return `${localizedPathFor(pathname, targetLocale)}${search}${hash}`;
}

export function isInternalPath(path: string): boolean {
  return !/^https?:\/\//.test(path) && !path.startsWith('mailto:') && !path.startsWith('tel:');
}
